'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = setUserId;

var _constants = require('./constants');

var _isInitialised = require('./isInitialised');

var _isInitialised2 = _interopRequireDefault(_isInitialised);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function setUserId(globalSnowplowName, userId) {
  if ((0, _isInitialised2.default)(globalSnowplowName)) {
    window[globalSnowplowName](_constants.SET_USERID, userId);
  }
}
module.exports = exports['default'];